// noinspection DuplicatedCode

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Table from '@/modules/common/components/Table';
import TableContainer from '@/modules/common/components/TableContainer';
import { getUserType, formatDateTime } from '~/common';

const Component = (props) => {
    const getClassName = (user) => {
        let className = 'context-menu';
        if (props.selectedUser && props.selectedUser.id === user.id) {
            className += ' selected';
        }
        return className;
    };
    // noinspection JSValidateTypes,JSUnresolvedVariable
    return (
        <TableContainer><Table>
            <TableHead><TableRow>
                <TableCell>Имя пользователя</TableCell>
                <TableCell className="user_type">Тип пользователя</TableCell>
                <TableCell className="last_login">Последний вход</TableCell>
            </TableRow></TableHead>
            <TableBody>
                {props.users.map((user) => (
                    <TableRow key={user.id} className={getClassName(user)} onContextMenu={props.onContextMenu(user)}>
                        <TableCell>
                            <Link to={`/users/${user.username}/`}>{user.username}</Link>
                        </TableCell>
                        <TableCell className="user_type">{getUserType(user.user_type)}</TableCell>
                        <TableCell className="last_login">
                            {(user.last_login)
                                ? <>{formatDateTime(new Date(user.last_login))}</>
                                : null
                            }
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table></TableContainer>
    );
};

Component.propTypes = {
    users: PropTypes.array.isRequired,
    selectedUser: PropTypes.object,
    onContextMenu: PropTypes.func.isRequired,
};

export default Component;
